module.exports = __webpack_public_path__ + "img/green-house.c348840c.jpg";